<template>
  <div class="menu-form">

    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  {{$t('category.group_tag')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label" v-show="false">
              <span style="margin-right: 15px;">
                {{$t('category.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" class="header mb-0">
            <div slot="header">
              <span >
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.basic_information') }}</strong>
              </span>
            </div>
            <b-form class="" v-if="item != null">
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.name')}}</legend>
                <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                  <b-form-input type="text"
                                :name="`name[${lang}]`"
                                class="form-control border-radius-4px"
                                v-model="item.name[lang]"
                                :state="!$v.item.name[lang].$invalid"
                                :aria-describedby="'name-feedback'+lang"
                                v-bind:placeholder="$t('common.text_' + lang)"
                  />
                  <b-form-invalid-feedback :id="'name-feedback'+lang">
                    <span v-if="!$v.item.name[lang].required">{{ $t('message.required_filed') }}</span>
                    <span v-else-if="!$v.item.name[lang].uniqueTag">{{ $t('message.tag_exist') }}</span>
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.description')}}</legend>
                <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                  <b-form-textarea class="form-control border-radius-4px" v-model="item.description[lang]" :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_' + lang)">
                  </b-form-textarea>
                </div>
              </div>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">
                  {{$t('category.banner')}}
                  <!-- <i class="fa fa-info-circle text-primary" id="image-banner"></i> -->
                  <b-tooltip target="image-banner" placement="top">
                    <div class="text-left" v-html="getImageHelpInfo('category', 'banner')"></div>
                  </b-tooltip>
                </legend>
                <div class="col-sm-5">
                  <b-form-file class="border-radius-4px" id="bannerData" @change="previewBanner" ref="banner" accept="image/*"></b-form-file>
                  <div class="image-desktop-preview">
                    <img class="preview-image" :src="bannerData != '' ? bannerData : item.image['banner']">
                  </div>
                </div>
              </div>
              <div class="form-group row hide">
                <legend class="col-sm-2 col-form-label">{{$t('category.sequence')}}</legend>
                <div class="col-sm-10">
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.sequence"
                    :state="!$v.item.sequence.$invalid"
                    :aria-describedby="'sequence-feedback'" />
                  <b-form-invalid-feedback :id="'sequence-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-form>
            <hr/>
            <b-row>
              <b-col>
                <button type="button" class="btn border-radius-4px bg-main pull-left" v-on:click="cancel()" ><i class="fa fa-times"></i>&nbsp;{{$t('common.close')}}</button>
                <div class="btn-save">
                  <button type="button" class="btn border-radius-4px bg-main pull-right" v-on:click="saveGroupTag()"><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue, email, decimal, or, numeric } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  let vm = null

  export default {
    name: 'SingleTypeForm',
    props: {
      uuid: {
        type: String
      },
      existTags: {
        type: Object
      }
    },
    components: {
      Tables,
      cSwitch
    },
    data: function () {
      return {
        oldTag: {},
        bannerData: 'https://static.phdvasia.com/jp/banners/banner.jpg',
        default_item: {
          uuid: '',
          name: {},
          description: {},
          customize: {},
          image: {},
          active: 1,
          sequence: 0
        },
        item: {
          uuid: '',
          name: {},
          description: {},
          customize: {},
          image: {},
          active: 1,
          sequence: 0
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations () {
     return {
       item: {
         sequence: {
           required,
           integer
         },
         name: this.nameRules
       }
     }
    },
    computed: {
      nameRules () {
        let result = {}
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          result[langs[l]] = {
            required,
            uniqueTag (value) {
              if (!value) {
                return true
              }
              if (this.oldTag) {
                if (this.oldTag.hasOwnProperty(langs[l]) && this.oldTag[langs[l]] && this.oldTag[langs[l]].toLowerCase() == value.toLowerCase()) {
                  return true
                }
              }
              return this._.indexOf(this.existTags[langs[l]], value.toLowerCase()) < 0
            }
          }
        }
        return result
      }
    },
    methods: {

      resetItem () {
        this.item = {
          uuid: '',
          name: {},
          description: {},
          customize: {},
          image: {},
          active: 1,
          sequence: 0
        }
      },
      cancel () {
        this.$emit('cancel')
      },
      previewBanner (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            this[input.id] = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.item.image['banner'] = input.files[0]
        }
      },
      /**
       * upload image then move to next form
       */
      saveGroupTag () {
        let item = vm.item

        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {'Content-Type': 'multipart/form-data'}
        // call an API to save image
        vm.axios.category.uploadSingleTypeImages(formData, config, function (response) {
          item.image = {}
          for (let i in response.data.data.item) {
            item.image[i] = response.data.data.item[i]
          }
          // get old url
          for (let i in oldUrl) {
            item.image[i] = oldUrl[i]
          }
          vm.imageData = item.image

          if (item.name_seo == null) {
            item.name_seo = ''
          }
          if (item.sequence == null) {
            item.sequence = 0
          }

          // save category
          if (vm.uuid === 'create' || vm.uuid === undefined) {
            vm.axios.category.createSingleType(item, respone => {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.resetItem()
              vm.$emit('success')
            }, error => {
              vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
              console.log('error', error)
            })
          } else {
            // update category
            vm.axios.category.updateSingleType(item, respone => {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.resetItem()
              vm.$emit('success')
            }, error => {
              vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
              console.log(error)
            })
          }
        })
      },
      getData () {
        this.oldTag = {}
        if (vm.uuid === '' || vm.uuid === 'create' || vm.uuid === undefined) {
          vm.item = this._.cloneDeep(vm.default_item)
        } else {
          vm.axios.category.getSingleTypeDetail(vm.uuid, function (response) {
            if (response.status === 200) {
              let item = response.data.data.item
              vm.oldTag = vm._.cloneDeep(item.name)
              if (item.name == null) {
                item.name = {}
              }
              if (item.description == null) {
                item.description = {}
              }
              vm.item = item
              vm.bannerData = vm.item.image['banner']
            }
          }, error => {
            console.log('error', error)
          })
        }
      }
    },
    created: function () {
      vm = this
    },
    mounted: function () {
      this.getData()
    },
    watch: {
      uuid: function (val) {
        this.getData()
      }
    }
  }
</script>
<style>
  input[type='file'], .custom-file-input, .custom-file-label {
    border-radius: 4px !important;
  }
</style>
<style scoped>
  .switch-title {
    width: auto !important;
  }
  .menu-form .btn-save{
    float: right;
  }
  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .col-form-label {
    padding-right: 10px;
  }

  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .custom-checkbox {
    padding-left: 0px;
  }

  .col-6{
    float: left;
  }

  #lunch_txt {
    padding-left: 20px;
  }

  .selected-category {
    background: #e1e6eb;
    padding: 7px 10px;
    border-radius: 30px;
    margin-right: 15px;
    color: #000;
    margin-top: 10px;
    float: left;
  }

  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #0091ff;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .preview-image {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/category/SingleTypeForm.vue